<template>
  <v-row justify="center">
    <v-dialog v-model="open" persistent width="640px">
      <v-card flat>
        <v-toolbar elevation="0">
          <v-toolbar-title class="ml-2 text--subtitle">
            <b>{{ $t('message.pages.noSubscriptionModal.title') }}</b>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pb-0">
          <v-row no-gutters align="center" justify="center">
            <img
              class="notice-img"
              :style="
                isMobileBreakpoint ? 'max-height: 130px;' : 'height: 230px'
              "
              src="@/assets/blueSadFeeling.svg"
            />
            <span class="mx-4 subtitle-2">
              <span
                v-html="$t('message.pages.noSubscriptionModal.subtitle')"
                class="mr-1"
              >
              </span>
              <a @click="handleChat">{{
                $t('message.pages.noSubscriptionModal.subtitle2')
              }}</a>
              <!-- <button
                type="button"
                class="primary--text"
                @click="handleTalkToUs"
              >
                <span class="primary--text">{{$t('message.pages.noSubscriptionModal.subtitleHelper')}}</span>
              </button> -->
            </span>
          </v-row>
        </v-card-text>
        <v-card-actions class="my-3">
          <v-row no-gutters class="justify-end">
            <v-btn
              v-if="!isMobileBreakpoint"
              text
              class="button-link"
              v-html="$t('message.pages.noSubscriptionModal.negativeAction')"
            >
            </v-btn>
            <v-btn
              :block="isMobileBreakpoint"
              :disabled="!isRootUser"
              class="primary white--text"
              min-width="150px"
              text
              @click="handleCart"
            >
              <span class="mx-3">
                {{ $t('message.pages.noSubscriptionModal.positiveAction') }}
              </span>
            </v-btn>
            <v-col cols="12" v-if="isMobileBreakpoint">
              <span
                style="font-size: 10px"
                class="text--text"
                v-html="$t('message.pages.noSubscriptionModal.negativeAction')"
              >
              </span>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'NoSubscriptionModal',
  components: {},
  data: () => ({
    open: false,
  }),
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    isRootUser() {
      return this.$store.state.user?.userAllInfo?.is_root ?? false
    },
  },
  mounted() {
    this.$root.$on('noSubscriptionModal', () => {
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('noSubscriptionModal')
  },
  methods: {
    handleClose() {
      this.open = false
    },
    handleLogout() {
      this.handleClose()
      this.$root.$emit('toolbarEventLogout')
    },
    handleCart() {
      this.handleClose()
      this.$router.push({ name: 'Cart' })
    },
    handleEvent(event) {
      const e = event
      if (e.key) {
        e.key === 'Escape' && this.handleClose()
      }
      return
    },
    handleTalkToUs() {},
    handleChat() {
      this.$crisp.push(['do', 'chat:show'])
      this.$crisp.push(['do', 'chat:open'])
    },
  },
}
</script>

<style scoped>
.notice-img {
  margin: 10px 0px 38px 0px;
}

@media only screen and (max-height: 680px) {
  .notice-img {
    height: 200px !important;
    margin: 8px 0px 30px 0px;
  }
}

@media only screen and (max-height: 535px) {
  .notice-img {
    height: 180px !important;
    margin: 0px 0px 28px 0px;
  }
}
</style>
